import type { NotificationRepository } from '../repositories/notification_repository'

export class DeleteNotificationUseCase {
  constructor(private readonly repository: NotificationRepository) {}

  execute(id: string): Promise<void> {
    return this.repository.delete(id)
  }
}
